var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.region)?_c('div',[_c('payment-order-layout',{attrs:{"regionAlias":_vm.region,"sudAlias":_vm.sud}})],1):_c('div',[_c('payment-order-change-region-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }